import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, CircularProgress, Alert, List, ListItem, ListItemText, Chip, Button } from '@mui/material';
import { Event, AccessTime } from '@mui/icons-material';
import axios from 'axios';

const MaxApp: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const initMaxApp = async () => {
      // Ждем, пока MAX Bridge загрузится
      if (!(window as any).WebApp) {
        setError('Приложение должно быть открыто внутри MAX');
        setLoading(false);
        return;
      }

      const webApp = (window as any).WebApp;
      webApp.ready(); // Сообщаем MAX, что мы готовы

      try {
        // Отправляем initData на наш бэкенд для валидации
        const response = await axios.post('/api/max-app/me', {
          initData: webApp.initData
        });
        setData(response.data);
      } catch (err: any) {
        console.error(err);
        setError(err.response?.data?.error || 'Ошибка загрузки данных');
      } finally {
        setLoading(false);
      }
    };

    initMaxApp();
  }, []);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>;

  if (error) return <Box sx={{ p: 2 }}><Alert severity="error">{error}</Alert></Box>;

  return (
    <Box sx={{ p: 2, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Привет, {data.guide.name.split(' ')[1]}!
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 3 }}>
        Ваши назначенные экскурсии:
      </Typography>

      {data.assignments.length === 0 ? (
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <Typography color="textSecondary">У вас нет назначенных экскурсий</Typography>
        </Paper>
      ) : (
        <List>
          {data.assignments.map((item: any) => (
            <Paper key={item.id} sx={{ mb: 2, p: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                  <Event fontSize="small" />
                  <Typography variant="body2">{new Date(item.date).toLocaleDateString('ru-RU')}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                  <AccessTime fontSize="small" />
                  <Typography variant="body2">{item.time?.slice(0, 5)}</Typography>
                </Box>
              </Box>
              <Typography variant="subtitle1" fontWeight="bold">{item.tour_name}</Typography>
              {item.is_english === 1 && <Chip label="English" size="small" color="info" sx={{ mt: 1 }} />}
              
              <Button variant="outlined" color="error" size="small" fullWidth sx={{ mt: 2 }}>
                Не могу провести
              </Button>
            </Paper>
          ))}
        </List>
      )}
    </Box>
  );
};

export default MaxApp;
